module.exports = __webpack_public_path__ + "app-static/img/p_03.de49ba9b.jpg";